import {singlePanelUrlWithObject} from "../../../routes";

// Builds a link to show on the dashboard panels.
export const getPanelLink = (riskPanelIdentifier: string, recordCount: number) => {
  return singlePanelUrlWithObject({
    searchParams: null,
    riskPanelIdentifier,
    recordCount,
    maxRecordCountToNotReturnViewAllUrl: -1})
}

// The users, count and query state of a dashboard panel's full user query
export const usersFromQuery = (fullQuery: any) => ({
  isLoading: fullQuery.isLoading,
  isError: fullQuery.isError,
  count: fullQuery?.data?.length,
  users: fullQuery?.data,
});
